import React from "react";
import { withI18n } from "react-i18next";
import { client } from "../../../shared/apiClient";

import { withRouter } from "react-router";
import { RouteComponentProps } from "react-router-dom";
import { iRootState } from "../../../store";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../Theme/custom-toast.css";

import VideoDirectionModal from "../../Modals/VideoDirectionModal";
import { isTodayAudition, isPastAudition } from "../../../helpers";
import { IKioskSessionAuditionsDto } from "../../../interfaces/IKioskSessionAuditionsDto";

const queryString = require("qs");
const videoDirToastId = 1;

interface IState {
  showModal: boolean;
  scheduleId: string;
  isLoading: boolean;
}

interface IProps extends StateProps, DispatchProps, RouteComponentProps<any> {
  t?: any;
  history: any;
  match: any;
  scheduleId?: any; // This can also be coming from index.js wrapper which can be called externally...
  onClose?: (e:any) => void;
  // using something like kiosk/videoDirection/12345
}

// Need to be able to be called independently using only the ScheduleId
class Directions extends React.Component<IProps, IState> {
  public state: IState = {
    showModal: false,
    scheduleId: "",
    isLoading: false,
  };

  async componentDidMount() {
    try {
      this.setState({ isLoading: true });
      const { scheduleId, getSessionAuditions, match } = this.props;
      let sId = scheduleId;
      if (!sId) {
        if (!match || !match.params || !match.params.scheduleId) return;
        sId = match.params.scheduleId;
      }

      await getSessionAuditions(sId);
      this.setState({ scheduleId: sId });

      this.setState({ showModal: true });

      this.setState({ isLoading: false });
    } catch (error) {
      this.props.history.push("/500");
    }
  }

  onModalClose = (e: any, showToast?: boolean, aspToast?: string) => {
    e.preventDefault();
    const qsArgs = decodeURI(window.location.search).split("?")[1];
    const result = queryString.parse(qsArgs);
    if (result.back) {
      const bdType = this.props.sessionAuditions.bdType;
      const bdId = this.props.sessionAuditions.bdId;

      let redirectUrl = `${client.api.paths.domain}/castingworkbook/directors`;
      redirectUrl = bdType === 2 ? `${redirectUrl}/commercial` : redirectUrl;
      redirectUrl = `${redirectUrl}/projects-vcr.asp?`;
      redirectUrl = aspToast === "save" || aspToast === "sent"
        ? `${redirectUrl}vd=${aspToast}&`
        : redirectUrl;
      redirectUrl = `${redirectUrl}display=active&sbd=${bdId}#${bdId}`;

      window.location.href = redirectUrl;
    } else {
      if (!this.props.scheduleId) {
        this.props.history.push({
          pathname: `/`,
        });
      }
      this.setState({ showModal: false });
      this.showToastVideoDirection(showToast);
    }

    if (this.props.onClose) {
      this.props.onClose(e);
    }
  };

  showToastVideoDirection = (show: boolean) => {
    const { t } = this.props;
    if (!show) return;
    toast.success(t("Video Directions Updated!"), {
      position: "top-right",
      toastId: videoDirToastId,
    });
  };

  render() {
    const { sessionAuditions } = this.props;

    let pastAudition = false;
    if (
      sessionAuditions &&
      sessionAuditions.auditionsDetails &&
      sessionAuditions.auditionsDetails.length > 0
    ) {
      pastAudition = isPastAudition(
        sessionAuditions.auditionsDetails[
          sessionAuditions.auditionsDetails.length - 1
        ].auditionTime,
        sessionAuditions.auditionDate
      ) && !isTodayAudition(sessionAuditions.auditionDate);
    }

    const scheduleId = this.props.scheduleId || this.state.scheduleId;

    return (
      <>
        {/* <ToastContainer
          hideProgressBar={true}
          toastClassName="toaster--success"
          bodyClassName="toaster-body toaster__icon--success"
          autoClose={2000}
        /> */}
        {this.state.showModal && (
          <VideoDirectionModal
            show={this.state.showModal}
            session={sessionAuditions}
            pastAudition={pastAudition}
            onClose={this.onModalClose}
            scheduleId={scheduleId}
            isParentLoading={this.state.isLoading}
          />
        )}
      </>
    );
  }
}

interface StateProps {
  sessionAuditions: IKioskSessionAuditionsDto;
}

function mapStateToProps(state: iRootState): StateProps {
  return {
    sessionAuditions: state.kiosk.sessionAuditions,
  };
}

interface DispatchProps {
  getSessionAuditions: (id: string) => void;
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    getSessionAuditions: dispatch.kiosk.getSessionAuditions,
  };
}

export default withI18n()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(Directions))
);
